import { forwardRef } from 'react';
import { CoreTextField, CoreTextFieldProps } from '../_core';
import { clsx } from '../../utils';
import { defaultTextInputStyles } from './input.styles';

export const TextField = forwardRef((props: Omit<CoreTextFieldProps, 'ref'>, ref) => (
	<CoreTextField
		{...props}
		ref={ref}
		sx={clsx(defaultTextInputStyles, props.sx)}
		className={props.error ? 'Mui-error' : undefined}
	/>
));

TextField.displayName = 'TextField';
